import React, { useEffect, useState } from 'react'
import { CModal, CModalBody, CModalFooter, CAccordion, CAccordionBody, CFormCheck, CAccordionHeader, CAccordionItem, CFormLabel, CButton, CModalHeader, CModalTitle } from '@coreui/react'

import SaveExtra from '../../services/general/saveExtraData.api'
import Graytextarea from '../../components/Graytextarea'
import toast from 'react-hot-toast'
import { Info } from 'lucide-react'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderTreatmentPatientDifferentDiagnosisTest = ({ diagnosisName, isAllotedToProvider, setSelectedDifferentialDiagnosis, noteStructureRef,loggedUserProvider,patientID,changesInTreatmentShell, setChangesInTreatmentShell }) => {
  console.log(loggedUserProvider,patientID,changesInTreatmentShell, setChangesInTreatmentShell,'loggedUserProvider,patientID,changesInTreatmentShell, setChangesInTreatmentShell')
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState('')
  const [editValue, setEditValue] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [selectedSuggestion, setSelectedSuggestion] = useState([])
  const [editDdx, setEditDdx] = useState(false)
  const [fetchingDdxSuggestions, setFetchingDdxSuggestions] = useState(false)
  const [accordionAtFirst, setAccordionAtFirst] = useState([])
  const [activeDescriptionIndex, setActiveDescriptionIndex] = useState(null)
  const [activeNestedDescriptionIndex, setActiveNestedDescriptionIndex] = useState(null)
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(null)
  const [isEducationModalVisible, setIsEducationModalVisible] = useState(false)
  const [media ,setMedia] = useState([])
  const [ eduHeader , setEduHeader] = useState('')

  console.log('accordionAtFirst=>', accordionAtFirst)

  useEffect(() => {
    const ddxValues = noteStructureRef?.current?.patientDifferentialDiagnosis?.[diagnosisName] || ''

    if (ddxValues && ddxValues.length > 0) {
      if (typeof ddxValues === 'string' && ddxValues.trim().length > 0) {
        const ddxArray = ddxValues
          .split('\n')
          .map((item) => item.trim())
          .filter((item) => item.length > 0)

        setSelectedSuggestion(ddxArray)
        setValue(ddxValues)
      }
    }
  }, [noteStructureRef?.current?.patientDifferentialDiagnosis, visible, editDdx])


    const { getDifferentialDiagnosis,saveTestOfflineData,getTestOfflineData } = useIndexedDB()
    
  const getAllDiagnosisDifferential = async () => {
    setFetchingDdxSuggestions(true)
    // let data = await SaveExtra('Get_By_Type', 'differentialDiagnosis', '', '')
    let data = await getDifferentialDiagnosis()
 

    const findDiagnosisDifferential = data.find((item) => item?.Data?.diagnosis?.label === diagnosisName)

    let finalSuggestions = []

    console.log(findDiagnosisDifferential, 'findDiagnosisDifferential', diagnosisName)

    const accordions = findDiagnosisDifferential?.Data?.accordions || []

    console.log('findDiagnosisDifferential=>', findDiagnosisDifferential, accordions)
    // console.log(accordions, 'accordions findDiagnosisDifferential', diagnosisName)

    if (accordions.length > 0) {
      const first = accordions[0]

      if (first.children && first.children.length > 0) {
        finalSuggestions = first.children.map((child) => ({
          title: child.title,
          suggestions: child?.suggestions?.suggestionName || [],
          description: child?.description,
        }))
      } else {
        // finalSuggestions = first?.suggestions?.suggestionName || []; // this was commented because it shows belly pesy
      }

      setAccordionAtFirst(accordions[0])
      setSuggestions(finalSuggestions)
    }

    setFetchingDdxSuggestions(false)
  }

      const handleAddToOfflineDDx = async (modalText) => {
        console.log('adding ddx text', modalText)
      try {
        let dataOffline = await getTestOfflineData()
      if (dataOffline) {
        console.log('offlineData before adding ddx:', dataOffline);
        dataOffline = {
          ...dataOffline,
          [loggedUserProvider?.ID]: {
            ...dataOffline[loggedUserProvider?.ID],
            [patientID]: {
              ...dataOffline[loggedUserProvider?.ID][patientID],
              currentNote:{
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
                data: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                  patientDifferentialDiagnosis: {
                    ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.patientDifferentialDiagnosis,
                    [diagnosisName]: modalText
                  }
                }
              },
              saveDraft : true
            }
          }
        }
      }
      console.log('offlineData after adding ddx:', dataOffline);
      await saveTestOfflineData(dataOffline)
      } catch (error) {
        console.log(error)
      }
    }

  useEffect(() => {
    getAllDiagnosisDifferential()
  }, [])

   
 const userData = JSON.parse(localStorage.getItem('user'))
 const role = userData?.Role

  return (
    <>
      <CAccordion className=" " flush>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <div className="d-flex gap-3 align-items-center">
              <h7>Differential Diagnosis</h7>
              {isAllotedToProvider && (
                <CFormLabel
                  className="d-flex mt-2 text-white flex-column align-items-center justify-content-center shadow"
                  onClick={() => setVisible((p) => !p)}
                  style={{
                    width: '30px',
                    fontSize: '11px',
                    height: '30px',
                    borderRadius: '20px',
                    background: '#4363F2',
                    cursor: 'pointer',
                  }}
                >
                  DDX
                </CFormLabel>
              )}
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            <Graytextarea
              height="100px"
              value={value}
              onClick={() => {
                setEditValue(value)
                setEditDdx(true)
              }}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>

      {/* Add Modal */}
      {/* <CModal size="lg" visible={visible} alignment="center" backdrop="static" scrollable onClose={() => setVisible(false)} aria-labelledby="VerticallyCenteredScrollableExample2">
        <CModalHeader>
          <p className="p-0 m-0">Add Differential Diagnosis for {diagnosisName}</p>
        </CModalHeader>
        <CModalBody>
          {accordionAtFirst?.suggestions?.suggestionName?.length > 0 && (
            <div className="mb-3">
              {accordionAtFirst.suggestions.suggestionName.map((item, idx) => (
                <div key={idx}>
                  <CFormCheck
                    checked={selectedSuggestion.includes(item.name)}
                    onChange={() => {
                      if (selectedSuggestion.includes(item.name)) {
                        setSelectedSuggestion((prev) => prev.filter((i) => i !== item.name))
                      } else {
                        setSelectedSuggestion((prev) => [...prev, item.name])
                      }
                    }}
                    id={`suggestion-${idx}`}
                    label={item.name}
                  />
                </div>
              ))}
            </div>
          )}

          {fetchingDdxSuggestions ? (
            <p>Loading...</p>
          ) : (
            <>
              {Array.isArray(suggestions) && suggestions.length > 0 && typeof suggestions[0]?.name === 'string' ? (
                suggestions.map((item, idx) => (
                  <div key={idx}>
                    <CFormCheck
                      checked={selectedSuggestion.includes(item.name)}
                      onChange={() => {
                        if (selectedSuggestion.includes(item.name)) {
                          setSelectedSuggestion(selectedSuggestion.filter((i) => i !== item.name))
                        } else {
                          setSelectedSuggestion([...selectedSuggestion, item.name])
                        }
                      }}
                      id={item.name}
                      label={item.name}
                    />
                  </div>
                ))
              ) : (
                <CAccordion alwaysOpen>
                  {suggestions.map((group, idx) => (
                    <CAccordionItem itemKey={idx + 1} key={idx}>
                      <CAccordionHeader>{group.title}</CAccordionHeader>
                      <CAccordionBody className="px-3">
                        {group.suggestions.map((item, subIdx) => (
                          <div key={subIdx}>
                            <CFormCheck
                              checked={selectedSuggestion.includes(item.name)}
                              onChange={() => {
                                if (selectedSuggestion.includes(item.name)) {
                                  setSelectedSuggestion(selectedSuggestion.filter((i) => i !== item.name))
                                } else {
                                  setSelectedSuggestion([...selectedSuggestion, item.name])
                                }
                              }}
                              id={item.name}
                              label={item.name}
                            />
                          </div>
                        ))}
                      </CAccordionBody>
                    </CAccordionItem>
                  ))}
                </CAccordion>
              )}
            </>
          )}
        </CModalBody>

        <CModalFooter className="border-top p-2 m-0">
          <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              const existingLines = value
                .split('\n')
                .map((line) => line.trim())
                .filter(Boolean)
              const newLines = selectedSuggestion.filter((s) => !existingLines.includes(s))
              const finalValue = [...selectedSuggestion].join('\n')

              setValue(finalValue)
              setVisible(false)

              noteStructureRef.current = {
                ...noteStructureRef.current,
                patientDifferentialDiagnosis: {
                  ...noteStructureRef.current.patientDifferentialDiagnosis,
                  [diagnosisName]: finalValue,
                },
              }

              setSelectedSuggestion([])
              toast.success('Successfully Added')
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal> */}

      {/* dark mode */}
      <CModal size="lg" visible={visible} alignment="center" backdrop="static" scrollable centered onClose={() => setVisible(false)} aria-labelledby="VerticallyCenteredScrollableExample2">
        {/* Header */}
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Add Differential Diagnosis for {diagnosisName}
          </CModalTitle>
        </CModalHeader>

        {/* Body */}
        <CModalBody style={{ backgroundColor: '#282828', height: '50vh', maxHeight: '60vh', overflowY: 'auto' }} className="text-white">
          {accordionAtFirst?.suggestions?.suggestionName?.length > 0 && (
            <div className="mb-3">
              {accordionAtFirst.suggestions.suggestionName.map((item, idx) => (
                <div key={idx} className=" ">
                  <div className="d-flex gap-2">
                    <CFormCheck
                      className="text-white custom-checkbox"
                      checked={selectedSuggestion.includes(item.name)}
                      onChange={() => {
                        if (selectedSuggestion.includes(item.name)) {
                          setSelectedSuggestion((prev) => prev.filter((i) => i !== item.name))
                        } else {
                          setSelectedSuggestion((prev) => [...prev, item.name])
                        }
                      }}
                      id={`suggestion-${idx}`}
                      label={item.name}
                    />
                    <span className="d-flex align-items-center gap-1">
                      {
                        <div style={{ cursor: 'pointer' }} onClick={() => setActiveDescriptionIndex((prev) => (prev === idx ? null : idx))}>
                          <Info size={15} className="mb-1 text-white" />
                        </div>
                      }
                      {item?.attached && (item?.attached?.image?.length > 0 || item?.attached.video?.length > 0 || item?.attached?.document?.length > 0) && (
                        <CButton
                          className="rounded-pill p-0 d-flex align-items-center justify-content-center"
                          style={{
                            width: '16px',
                            height: '16px',
                            fontSize: '9px',
                            color: 'white',
                            border: '1px solid white',
                          }}
                          variant="outline"
                          onClick={() => {
                            const mergedMedia = [...(item?.attached?.image || []), ...(item?.attached?.video || []), ...(item?.attached?.document || [])]
                            setMedia(mergedMedia)
                            setIsEducationModalVisible(true)
                            setEduHeader(item.name)
                          }}
                        >
                          e
                        </CButton>
                      )}
                    </span>
                  </div>
                  <div>{activeDescriptionIndex === idx && <div style={{ color: '#FFDF00', whiteSpace: 'pre-line', fontSize: '12px', padding: '0 10px' }}>{item?.description}</div>} </div>
                </div>
              ))}
            </div>
          )}

          {fetchingDdxSuggestions ? (
            <p>Loading...</p>
          ) : (
            <>
              {Array.isArray(suggestions) && suggestions.length > 0 && typeof suggestions[0]?.name === 'string' ? (
                suggestions.map((item, idx) => (
                  <div key={idx}>
                    <CFormCheck
                      className="text-white custom-checkbox"
                      checked={selectedSuggestion.includes(item.name)}
                      onChange={() => {
                        if (selectedSuggestion.includes(item.name)) {
                          setSelectedSuggestion(selectedSuggestion.filter((i) => i !== item.name))
                        } else {
                          setSelectedSuggestion([...selectedSuggestion, item.name])
                        }
                      }}
                      id={item.name}
                      label={item.name}
                    />
                  </div>
                ))
              ) : (
                <div className={` ${role == 'provider' ? 'accordion-dark' : ' '} px-2 overflow-hidden`}>
                  <CAccordion alwaysOpen className="transparentAccordion">
                    {suggestions.map((group, idx) => (
                      <CAccordionItem itemKey={idx + 1} key={idx} className="mt-2 treatment ">
                        <CAccordionHeader className="position-relative">
                          <div>{group.title}</div>

                          {/* Place Info icon in the top-right corner */}
                          {group?.description !== '' && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '-1px',
                                right: '25px',
                                cursor: 'pointer',
                              }}
                              onClick={(e) => {
                                e.stopPropagation() // Prevent accordion toggle
                                setActiveAccordionIndex((prev) => (prev === idx ? null : idx))
                              }}
                            >
                              <Info size={15} className="text-white" />
                            </div>
                          )}
                        </CAccordionHeader>
                        {activeAccordionIndex === idx && <div style={{ color: '#FFDF00', whiteSpace: 'pre-line', fontSize: '12px', padding: '0 10px' }}>{group?.description}</div>}
                        <CAccordionBody className="px-3 text-white ">
                          {group.suggestions.map((item, subIdx) => (
                            <div key={subIdx}>
                              <div className="d-flex gap-2">
                                <CFormCheck
                                  className="text-white custom-checkbox"
                                  checked={selectedSuggestion.includes(item.name)}
                                  onChange={() => {
                                    if (selectedSuggestion.includes(item.name)) {
                                      setSelectedSuggestion(selectedSuggestion.filter((i) => i !== item.name))
                                    } else {
                                      setSelectedSuggestion([...selectedSuggestion, item.name])
                                    }
                                  }}
                                  id={item.name}
                                  label={item.name}
                                />
                                <div className="d-flex align-items-center gap-1">
                                  {item?.description != '' && (
                                    <div style={{ cursor: 'pointer' }} onClick={() => setActiveNestedDescriptionIndex((prev) => (prev === subIdx ? null : subIdx))}>
                                      <Info size={15} className="mb-1 text-white" />
                                    </div>
                                  )}
                                  {
                                    <CButton
                                      className="rounded-pill p-0 d-flex align-items-center justify-content-center"
                                      style={{
                                        width: '16px',
                                        height: '16px',
                                        fontSize: '9px',
                                        color: 'white',
                                        border: '1px solid white',
                                      }}
                                      variant="outline"
                                      onClick={() => {
                                        const mergedMedia = [...(item?.attached?.image || []), ...(item?.attached?.video || []), ...(item?.attached?.document || [])]
                                        setMedia(mergedMedia)
                                        setIsEducationModalVisible(true)
                                        setEduHeader(item.name)
                                      }}
                                    >
                                      e
                                    </CButton>
                                  }
                                </div>
                              </div>
                              <div>{activeNestedDescriptionIndex === subIdx && <div style={{ color: '#FFDF00', whiteSpace: 'pre-line', fontSize: '12px', padding: '0 0px' }}>{item?.description}</div>} </div>
                            </div>
                          ))}
                        </CAccordionBody>
                      </CAccordionItem>
                    ))}
                  </CAccordion>
                </div>
              )}
            </>
          )}
          {console.log('loading data', fetchingDdxSuggestions, accordionAtFirst?.suggestions?.suggestionName?.length, suggestions)}
          {!fetchingDdxSuggestions && (!accordionAtFirst?.suggestions?.suggestionName || (Array.isArray(accordionAtFirst?.suggestions?.suggestionName) && accordionAtFirst?.suggestions?.suggestionName.length === 0)) && (!Array.isArray(suggestions) || suggestions.length === 0) && (
            <div
              style={{
                fontSize: '15px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontWeight: 600,
                color: 'gray',
              }}
            >
              No Differential Diagnosis Available
            </div>
          )}
        </CModalBody>

        {/* Footer */}
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            paddingTop: '10px',
          }}
        >
          <CButton
            style={{
              backgroundColor: '#4363F2',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => {
              const existingLines = value
                .split('\n')
                .map((line) => line.trim())
                .filter(Boolean)
              const newLines = selectedSuggestion.filter((s) => !existingLines.includes(s))
              const finalValue = [...selectedSuggestion].join('\n')

              setValue(finalValue)
              setVisible(false)

              noteStructureRef.current = {
                ...noteStructureRef.current,
                patientDifferentialDiagnosis: {
                  ...noteStructureRef.current.patientDifferentialDiagnosis,
                  [diagnosisName]: finalValue,
                },
              }
              handleAddToOfflineDDx(finalValue)

              setSelectedSuggestion([])
              toast.success('Successfully Added')
            }}
          >
            Save
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => setVisible(false)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      {/* Edit Modal */}
      <CModal size="lg" alignment="center" visible={editDdx} onClose={() => setEditDdx(false)} aria-labelledby="EditDdxModalLabel">
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
            id="EditDdxModalLabel"
          >
            Edit Differential Diagnosis
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            style={{
              backgroundColor: '#282828',
              color: 'white',
              border: '1px solid #989898',
              height: '200px',
            }}
          />
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            variant="outline"
            color="primary"
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={async() => {

              noteStructureRef.current = {
                ...noteStructureRef.current,
                patientDifferentialDiagnosis: {
                  ...noteStructureRef.current.patientDifferentialDiagnosis,
                  [diagnosisName]: editValue,
                },
              }
              await handleAddToOfflineDDx(editValue)
              setValue(editValue)
              setEditDdx(false)
              toast.success('Successfully Saved')
            }}
          >
            Save
          </CButton>
          <CButton
            variant="outline"
            color="secondary"
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => setEditDdx(false)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal visible={isEducationModalVisible} alignment="top" size="lg" onClose={() => setIsEducationModalVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#151515',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <h5 className="text-white">{eduHeader || 'Media'}</h5>
        </CModalHeader>

        <CModalBody style={{ backgroundColor: '#151515', color: 'white', height: '200px' }}>
          <div style={{ height: '165px', overflow: 'auto' }}>
            {console.log('media->', media)}
            {media?.length > 0 ? (
              <div className="d-flex flex-wrap align-items-center gap-2">
                {media.map((fileItem, i) => {
                  const isImage = fileItem.type === 'image'
                  const isVideo = fileItem.type === 'video'
                  const isDocument = fileItem.type === 'document'

                  return (
                    <div key={i} className="d-flex flex-column gap-2 align-items-center">
                      <a
                        href={fileItem.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="shadow rounded p-2 position-relative d-block"
                        style={{
                          width: '100px',
                          height: '100px',
                          overflow: 'hidden',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          background: '#191919',
                          textDecoration: 'none',
                        }}
                      >
                        {isVideo ? (
                          <video
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '8px',
                            }}
                            controls
                          >
                            <source src={fileItem.url} type="video/mp4" />
                          </video>
                        ) : isImage ? (
                          <img
                            src={fileItem.url}
                            alt="Uploaded"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '8px',
                            }}
                          />
                        ) : isDocument ? (
                          <iframe
                            src={fileItem.url}
                            title="Document Viewer"
                            style={{
                              width: '100%',
                              height: '100%',
                              border: 'none',
                              borderRadius: '8px',
                              pointerEvents: 'none',
                            }}
                          />
                        ) : (
                          <div
                            className="text-center"
                            style={{
                              color: '#000',
                              fontSize: '0.75rem',
                              padding: '10px',
                            }}
                          >
                            {fileItem.fileName || 'File'}
                          </div>
                        )}
                      </a>
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="text-center text-light ">No files available</div>
            )}
          </div>
        </CModalBody>

        <CModalFooter style={{ backgroundColor: '#151515' }}>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => setIsEducationModalVisible(false)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderTreatmentPatientDifferentDiagnosisTest
